import { render, staticRenderFns } from "./bar-chart.component.vue?vue&type=template&id=2229ad1c&scoped=true"
import script from "./bar-chart.component.vue?vue&type=script&lang=ts"
export * from "./bar-chart.component.vue?vue&type=script&lang=ts"
import style0 from "./bar-chart.component.vue?vue&type=style&index=0&id=2229ad1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2229ad1c",
  null
  
)

export default component.exports